import { Link } from "react-router-dom";
import { BLOG } from "@/data/content";
import { Reveal, Overline, Btn } from "@/components/common/ui";

export default function Blog() {
  const [feature, ...rest] = BLOG;
  return (
    <div data-testid="blog-page" className="bg-[#FFFCFA]">
      <header className="border-b border-[#F2E8E6] bg-white py-20 text-center md:py-28">
        <Overline>The Journal</Overline>
        <h1 className="mt-4 font-display text-5xl font-light text-[#2C2B2C] sm:text-7xl">Glow notes & guides</h1>
        <p className="mx-auto mt-5 max-w-xl px-6 text-base font-light text-[#8A7F86]">
          Science, rituals and inspiration for your next self-care moment.
        </p>
      </header>

      <div className="mx-auto max-w-[1400px] px-6 py-20 md:px-12">
        {/* Featured */}
        <Reveal>
          <Link to={`/blog/${feature.slug}`} className="group grid gap-8 rounded-[2rem] border border-[#F2E8E6] bg-[#FFFCFA] md:grid-cols-2" data-testid="blog-featured">
            <div className="hover-zoom overflow-hidden">
              <img src={feature.cover} alt={feature.title} className="h-full min-h-[20rem] w-full object-cover" />
            </div>
            <div className="flex flex-col justify-center p-8 md:p-12">
              <span className="text-xs uppercase tracking-[0.18em] text-[#FBC4A8]">{feature.tags[0]} · {feature.read}</span>
              <h2 className="mt-4 font-display text-3xl font-light leading-tight text-[#2C2B2C] group-hover:text-[#FBC4A8] sm:text-4xl">{feature.title}</h2>
              <p className="mt-4 text-base font-light leading-relaxed text-[#8A7F86]">{feature.excerpt}</p>
              <span className="mt-6 text-xs uppercase tracking-[0.18em] text-[#2C2B2C] underline underline-offset-4">Read Article</span>
            </div>
          </Link>
        </Reveal>

        {/* Grid */}
        <div className="mt-10 grid gap-7 md:grid-cols-3">
          {rest.map((post, i) => (
            <Reveal key={post.slug} delay={i * 0.1}>
              <Link to={`/blog/${post.slug}`} className="group flex flex-col rounded-[2rem] border border-[#F2E8E6] bg-[#FFFCFA]" data-testid={`blog-card-${post.slug}`}>
                <div className="hover-zoom overflow-hidden">
                  <img src={post.cover} alt={post.title} className="h-56 w-full object-cover" />
                </div>
                <div className="flex flex-1 flex-col p-7">
                  <span className="text-xs uppercase tracking-[0.18em] text-[#FBC4A8]">{post.tags[0]} · {post.read}</span>
                  <h3 className="mt-3 font-display text-2xl leading-tight text-[#2C2B2C] group-hover:text-[#FBC4A8]">{post.title}</h3>
                  <p className="mt-3 text-sm font-light leading-relaxed text-[#8A7F86]">{post.excerpt}</p>
                  <span className="mt-5 text-xs text-[#8A7F86]">{post.date}</span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
